export default __webpack_public_path__ + "static/media/manage-accounts.960b5ff1.svg";